"use client";

import type { Bilingual, Locale } from "@/types/insights";
import { useLocale } from "next-intl";

/** Category filter rail (controlled by the parent, panel-managed categories). */
export default function CategoryRail({
  categories,
  active,
  onChange,
}: {
  categories: { id: string; label: Bilingual }[];
  active: string;
  onChange: (k: string) => void;
}) {
  const locale = useLocale() as Locale;
  if (categories.length <= 1) return null;
  return (
    <div className="mx-auto max-w-360 overflow-x-auto border-b border-black/10 px-6 lg:px-10 dark:border-white/10">
      <div className="flex min-w-max gap-2 py-4">
        {categories.map((c) => (
          <button
            key={c.id}
            onClick={() => onChange(c.id)}
            className={`border px-4 py-2 text-[11px] font-semibold uppercase tracking-wider transition-colors ${
              active === c.id
                ? "border-accent bg-accent text-white"
                : "border-black/15 text-ash/60 hover:border-ash hover:text-ash dark:border-white/15 dark:text-white/60 dark:hover:border-white dark:hover:text-white"
            }`}
          >
            {c.label[locale]}
          </button>
        ))}
      </div>
    </div>
  );
}
